<script setup lang="ts">
import { computed } from 'vue'
import JDatepicker from '@/components/atoms/JDatepicker.vue'
import { cn } from '@/lib/utils'

export type DateRangeValue = { start: string | null; end: string | null }

const props = withDefaults(
  defineProps<{
    modelValue?: DateRangeValue
    min?: string
    max?: string
    disabled?: boolean
    required?: boolean
    placeholder?: { start?: string; end?: string }
    separator?: string
    class?: string
    id?: string
    name?: string
  }>(),
  {
    separator: '~',
  }
)

const emit = defineEmits<{
  'update:modelValue': [value: DateRangeValue]
  'change': [value: DateRangeValue]
  'focus': [event: FocusEvent]
  'blur': [event: FocusEvent]
}>()

const current = computed<DateRangeValue>(() => props.modelValue ?? { start: null, end: null })

const handleChange = (key: 'start' | 'end', val: string | null) => {
  const next = { ...current.value, [key]: val }
  emit('update:modelValue', next)
  emit('change', next)
}
</script>

<template>
  <div :class="cn('flex items-center gap-1 w-full', props.class)">
    <JDatepicker
      :model-value="current.start"
      :disabled="disabled"
      :required="required"
      :placeholder="placeholder?.start ?? '시작일'"
      class="flex-1"
      @update:model-value="handleChange('start', $event)"
      @focus="emit('focus', $event)"
      @blur="emit('blur', $event)"
    />
    <span class="text-muted-foreground text-xs shrink-0 select-none px-0.5">{{ separator }}</span>
    <JDatepicker
      :model-value="current.end"
      :disabled="disabled"
      :required="required"
      :placeholder="placeholder?.end ?? '종료일'"
      class="flex-1"
      @update:model-value="handleChange('end', $event)"
      @focus="emit('focus', $event)"
      @blur="emit('blur', $event)"
    />
  </div>
</template>
